<template>
    <section class="tabDetail position-relative">

        <v-tabs
                v-model="tab"
                @change="changeTab"
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows
        >
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in filteredItems" :key="item.label">
        <span class="tabDetail__tab">
          {{ item.label }}
        </span>
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item v-for="tabItem in filteredItems" :key="tabItem.label">
                <v-card flat>
                    <div class="tabDetail__grid" v-html="tabItem.descr"></div>
                    
                    <div v-if="Array.isArray(tabItem.additional) && tabItem.additional.length > 0"
                         class="tabDetail__files-grid">
                        <div v-for="(file, index) in tabItem.additional" :key="index"
                             class="tabDetail__item position-relative">
                            <a :href="file.link" target="_blank" class="tabDetail__link position-absolute"></a>
                            <img src="/upload/pad_img.svg" alt="" class="tabDetail__img-icon">
                            <h3 class="tabDetail__title">{{ file.title }}</h3>
                            <div class="tabDetail__download">
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://w3.org">
                                        <path d="M4 15.2044L4 18.8925C4 19.4514 4.21071 19.9875 4.58579 20.3827C4.96086 20.778 5.46957 21 6 21H18C18.5304 21 19.0391 20.778 19.4142 20.3827C19.7893 19.9875 20 19.4514 20 18.8925V15.2044M12.0011 3V14.9425M12.0011 14.9425L16.5725 10.3793M12.0011 14.9425L7.42969 10.3793"
                                              stroke="#F94237" stroke-width="2" stroke-linecap="round"
                                              stroke-linejoin="round"></path>
                                    </svg>
                                </span>
                                Скачать
                            </div>
                        </div>
                    </div>


                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </section>
</template>

<script>
export default {
    name: "tabDetail",
    props: {
        tabs: [Array, Object, String],
    },
    data() {
        return {
            tab: 0, // по умолчанию первый таб

            /*items: [
              {
                label: "Описание",
                descr: 'тест тест рецептура позволяет добиться стабильной работы данной марки в агрессивных условиях эксплуатации (высокая скорость упаковки, выступающие острые углы паллеты). Инновационная стретч-пленка, предназначенная для групповой упаковки грузов на поддоне с целью дальнейшей транспортировки при помощи упаковочного оборудования с частотой вращения манипулятора до 72 об/мин и высоким уровнем предварительного растяжения. При работе на частотах свыше 40 об/мин рабочее предварительное растяжение снижается пропорционально скорости. <p></p> Отличается повышенной устойчивостью к проколу, а также высокой прочностью к растяжению, что обеспечивает преимущество в сравнении \n' +
                    'с базовыми марками к сдвигам групповой упаковкипри транспортировке. Рекомендована для упаковки тяжёлых грузов, а также для перехода \n' +
                    'с базовых и универсальных стретч-плёнок на стретч-плёнку меньшей толщины.',
                additional:{
                  link:'',
                  title:'',
                }

              },
              {
                label: "Область применения",

                descr: 'Тест тест тест тест тест тест тест тест тест тест тест тест тест тест тест',


              },
              {
                label: "Дополнительные свойства",

                descr: 'Тест тест тест тест тест тест тест тест тест тест тест тест тест тест тест',


              },
            ],*/
            items: this.tabs,
        }
    },

    methods: {
        // вызывается при переключении таба
        changeTab(newIndex) {
            console.log("changeTab", newIndex);

        },
    },
    computed: {
        // не показываем табы, если нет описания или документа
        filteredItems() {
            if (!Array.isArray(this.tabs)) return [];
            return this.tabs.filter(item => {
                const hasDescr = item.descr && item.descr.trim() !== '';
                const hasDoc = Array.isArray(item.additional) && item.additional.length > 0;

                return hasDescr || hasDoc;
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.tabDetail {
  //margin-bottom: 80px;


  &__select {
    margin: 32px 0;
  }

  &__content {
    border-radius: 40px !important;
    background: #F5F5F7;
  }


  &__info {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    flex-direction: column;
    align-items: start;
    height: 100%;
    margin-top: 0 !important;

    @media (max-width: 900px) {
      position: unset;
    }
  }


  &__img {
    border-radius: 40px;
    max-width: 1840px;
    width: 100%;
    height: 100%;
    max-height: 790px;
    object-fit: cover;
  }

  &__dots {
    position: relative;
  }

  &__dot {
    position: absolute;
    background: #f94237;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;

    &:before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #FFFFFF;
      width: 0.8rem;
      height: 0.8rem;;
      border-radius: 50%;
    }

    &:after {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #f94237;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
    }
  }


  &__item {
    position: relative;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #E8E8E8;
    border-radius: 32px !important;

    &:hover,
    &:focus {
      border-color: #F94237;

      & .tabDetail__download {
        text-decoration: underline;
      }
    }


  }

  &__img-icon {
    width: 44px;
    height: 44px;
    object-fit: cover;
    display: block;
    margin-bottom: 24px;
  }

  &__link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__download {
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: "MuseoSansCyrl-500";
    font-weight: 400;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0px;
    color: #F94237 !important;
    margin: 0;
    text-decoration: underline transparent;
    width: max-content;
  }

}

</style>

<style lang="scss">

.tabDetail {

  .tabDetail__grid {
    font-family: "RobotoRegular";
    font-weight: 400;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    color: #4F4F4F;
    margin-top: 30px;
    padding: 0 5px;
  }

  .v-card .v-card--flat .v-sheet .theme--light {
    border-radius: 40px !important;
  }

  .v-tab:not(.v-tab--active) {
    & svg {
      display: none;
    }
  }

  & .v-tabs-slider {
    height: 0;
  }

  .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none;
  }

  .v-tabs {
    @media (max-width: 766px) {
      max-width: 90vw;
    }
  }

  & .v-tab {
    gap: 14px;
    margin: 5px;
    border: 1px solid #E8E8E8;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 16px 20px;
    height: 52px;

    @media (max-width: 1024px) {
      padding: 5px 60px;
    }

    @media (max-width: 1024px) {
      padding: 5px 20px;
    }

    &:hover {
      opacity: 1 !important;
      border-color: #4F4D55;
    }

    &:before {
      background-color: transparent !important;
    }

    & > span {
      font-family: 'MuseoSansCyrl-500';
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0;
      color: #4F4D55 !important;
      text-transform: none;
    }

    &--active {
      border: 1px solid #F94337;
      border-radius: 40px;
      mask-image: radial-gradient(white, black);
      will-change: transform;

      &:hover {
        opacity: 1 !important;
        border: 1px solid #FA4237;
      }

      &:before {
        background-color: transparent !important;
      }

      & > span {
        color: #F94337 !important;
      }
    }

  }

  & .v-tabs-bar {
    height: unset;
  }

  & .v-tabs-bar,
  & .theme--light.v-tabs-items {
    background-color: transparent !important;
  }

  .mdi-arrow-right-bold-box-outline::before {
    position: absolute;
    top: -10px;
    content: '';
    background: url("/local/templates/international/img/fi_chevron-down.svg") no-repeat;
    background-size: contain;
    width: 25px;
    height: 25px;
  }

  .mdi-arrow-left-bold-box-outline::before {
    position: absolute;
    top: -10px;
    content: '';
    background: url("/local/templates/international/img/fi_chevron-down.svg") no-repeat;
    background-size: contain;
    width: 25px;
    height: 25px;
    rotate: 180deg;
  }

  & .v-ripple__container {
    display: none;
  }

  .v-slide-group__next, .v-slide-group__prev {
    min-width: 33px;
  }

  .v-slide-group__wrapper {
    height: 60px;
  }

  .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__content {

    & .v-slide-group__content {
      display: block;
      flex: unset;
      width: 100%;
    }

    & .v-slide-group__wrapper {
      height: 100% !important;
    }

    & .theme--light.v-tabs > .v-tabs-bar {
      margin-bottom: 40px;
      height: 100%;
    }

    & .v-tabs {
      position: absolute;
      top: 0;
      height: 100%;
    }

    & .v-tab {
      min-width: unset !important;
      width: 2rem !important;
      height: 2rem !important;
      border-radius: 50% !important;
      padding: 0 !important;

      &--active {
        box-shadow: 0 0 0 0.5rem rgba(251, 66, 55, 0.5) !important;
        border: none;
        mask-image: none;

        &:before {
          display: none;
          background-color: transparent !important;
          width: 32px !important;
          height: 32px !important;
          border-radius: 50% !important;
        }
      }
    }

  }


}


</style>